/**
 * Attrition Page
 *
 * This is now a thin wrapper around the generic SystemWorkspacePage.
 * The actual workspace logic is handled by the generic component.
 */

import React from "react";
import { SystemWorkspaceWrapper } from "./SystemWorkspacePage";
import type { DatasetName } from "@/common/constants";

/**
 * Required datasets for the Attrition workspace
 */
const ATTRITION_REQUIRED_DATASETS: DatasetName[] = [
  "main",
  "benchmark",
  "attrition_directional_drivers",
];

/**
 * Attrition workspace page component
 */
const AttritionPage: React.FC = () => {
  return (
    <SystemWorkspaceWrapper
      workspaceId="attrition"
      requiredDatasets={ATTRITION_REQUIRED_DATASETS}
    />
  );
};

export default AttritionPage;
